import { toastController } from '@/controllers/toastController'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { BaseVm } from '@/mobxTools'
import { computed, observable } from 'mobx'
import { UploadHistoryModalProps } from './UploadHistoryModal'
import { debounce } from 'lodash'
import { uiController } from '@/controllers/uiController'

export class UploadHistoryModalVm extends BaseVm<UploadHistoryModalProps> {
  props!: UploadHistoryModalProps

  @observable limit = 15
  @observable total = 0
  @observable historyListLoading = false
  @observable historyListData: ServerDataTypes.PDF.PdfProHistoryInfo[] = []
  @observable keyword = ''

  loadingEle: HTMLDivElement | null = null
  scrollBox: HTMLDivElement | null = null
  observer: IntersectionObserver | undefined = undefined
  @observable hasMore = true

  @computed get noHistoryData() {
    return !this.historyListLoading && !this.hasMore && this.historyListData.length === 0
  }

  handleSearch = debounce(() => {
    this.historyListData = []
    this.hasMore = true
    this.loadMoreData()
  }, 200)

  public onViewCreate() {}

  loadMoreData = debounce(async () => {
    if (this.historyListLoading) {
      return
    }
    this.historyListLoading = true
    try {
      const { totalCount, dataList } = await api.pdf.getPdfProHistoryList(
        this.limit,
        this.historyListData.length,
        this.keyword.trim()
      )

      const replaceKeywordWithHighlight = (str: string, keyword: string) => {
        const regex = new RegExp(`(${keyword})`, 'gi')
        const replacedStr = str.replace(regex, (match) => {
          if (match.toLowerCase() === keyword.toLowerCase()) {
            return `<em>${match}</em>`
          } else {
            return match
          }
        })
        return replacedStr
      }

      dataList.forEach((item) => {
        if (this.keyword) {
          item.highlightName = replaceKeywordWithHighlight(item.fileName, this.keyword)
        } else {
          item.highlightName = item.fileName
        }
      })

      this.historyListData.push(...dataList)
      this.total = totalCount

      if (this.historyListData.length >= totalCount) {
        this.hasMore = false
      } else {
        this.hasMore = true
      }
    } catch (error) {
      toastController.error(
        commonUtils.formatErrorMsg(error, '阅读列表加载失败，请稍后重试或联系客服')
      )
    }
    this.historyListLoading = false
  }, 100)

  public resetLoadMore() {
    this.historyListData = []
    this.loadMoreData()
  }

  public async handleDeleteHistoryItem(item: ServerDataTypes.PDF.FileInfo) {
    uiController.commonModalProps = {
      open: true,
      confirmLoading: false,
      title: '提示',
      content: '删除后，此PDF不可恢复，再次上传会消耗PDF上传页数，是否删除？',
      okText: '删除',
      cancelText: '取消',
      onOk: async () => {
        uiController.commonModalProps.confirmLoading = true
        try {
          const fileId = item.fileId
          await api.pdf.deletePdfHistory(fileId)
          this.total = this.total - 1
          const targetIndex = this.historyListData.findIndex((item) => item.fileId === fileId)
          if (targetIndex !== -1) {
            this.historyListData.splice(targetIndex, 1)
          }

          toastController.success('删除成功')

          uiController.commonModalProps = { open: false }
        } catch (error) {
          uiController.commonModalProps.confirmLoading = false
          toastController.error(commonUtils.formatErrorMsg(error))
        }
      },
      onCancel: () => {
        uiController.commonModalProps = { open: false }
      },
    }
  }
}
